<template>
	<v-container>
		<v-row no-gutters>
			<v-col cols="6" md="4" lg="3" v-for="(user, i) in users" :key="i">
				<v-row no-gutters justify="center">
					<v-btn class="my-2" color="secondary" @click="login(user)">{{ user.full_name }}</v-btn>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from "axios"
import errorHandling from "../../helper/errorHandling"

export default {
	data() {
		return {
			users: [],
		}
	},
	mounted() {
		axios.get("/erp/v1/tests").then((res) => {
			this.users = res.data
		})
	},
	methods: {
		login(user) {
			const password = "12345678Aa"
			this.$store
				.dispatch("auth/login", {
					email: user.email,
					password: password,
				})
				.then((res) => {
					this.$store.commit("setFlash", {
						text: "ログインしました",
						type: "notice",
					})
					if (res.user_include_sales == true) {
						this.$router.push("/")
					} else {
						this.$router.push("/erp")
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>